import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  showInfo: boolean;
};

const ContractingNoEditableInfo = ({ showInfo }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // render
  return (
    <RenderWrapper isVisible={() => showInfo}>
      <p className="text-muted small font-italic mb-2">
        {tLabels("contractingNoEditableInfo.message")}
      </p>
    </RenderWrapper>
  );
};

export default ContractingNoEditableInfo;
